import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CompanyRegistrationHeader from '../components/Service/Consultation/CompanyRegistrationHeader';
import CompanyRegistrationInfo from '../components/Service/HrRecruitment/CompanyRegistrationInfo';
import ConditionsForRegister from '../components/Service/HrRecruitment/ConditionsForRegister';
import RegistrationProcess from '../components/Service/HrRecruitment/RegistrationProcess';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';
import OfflineConsultation from '../components/Service/ConsultationForm/OfflineConsultation';

export default function ConsultationOfflineConsultation() {
    const [activity, setActivity] = useState({});
    return (
        <>
            <Header />
            <CompanyRegistrationHeader activity={activity} />
            <OfflineConsultation activity={activity} setActivity={setActivity} />
            {/* <ConditionsForRegister /> */}
            {/* <RegistrationProcess /> */}
            
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}
